import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.toggleShow = this.toggleShow.bind(this);
    this.state = { type: 'password', eyeClass: 'password-show-icon', eyeCon: 'eye' }
    this.iconStyle = {
      float: 'right',
      marginLeft: '-25px',
      marginTop: '-25px',
      position: 'relative',
      zIndex: 2
    }
  }

  toggleShow() {
    if (this.state.type === 'password')
      this.setState({ type: 'text', eyeClass: 'password-show-icon', eyeCon: 'eye-slash' });
    else
      this.setState({ type: 'password', eyeClass: 'password-show-icon', eyeCon: 'eye' });
  }

  render() {
    return (<div>
      <Input type={this.state.type} {...this.props} style={{display: 'inline'}} className="form-control" ></Input>
      <FontAwesomeIcon icon={this.state.eyeCon} className={this.state.eyeClass} onClick={this.toggleShow}/>
    </div>);
  }
}
